import BiLink from './BiLink'

export default BiLink
